// websocket-client.ts - Client WebSocket simplu în TypeScript
import { io, Socket } from 'socket.io-client';

type UpdateType = 'cmr' | 'vehicle' | 'shipment';
type UpdateCallback<T = any> = (data: T) => void;

class SimpleWebSocket {
  private socket: Socket | null = null;
  private isConnected = false;
  private callbacks: Record<UpdateType, UpdateCallback[]> = {
    cmr: [],
    vehicle: [],
    shipment: [],
  };

  constructor() {
    this.init();
  }

  private init(): void {
    const token =
      localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    if (!token) return;

    this.socket = io(window.location.origin, {
      auth: { token },
    });

    this.socket.on('connect', () => {
      console.log('✅ WebSocket conectat');
      this.isConnected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('❌ WebSocket deconectat');
      this.isConnected = false;
    });

    // Evenimente pentru actualizări
    this.socket.on('cmr_document_updated', (data: any) => {
      this.handleUpdate('cmr', data);
    });

    this.socket.on('vehicle_updated', (data: any) => {
      this.handleUpdate('vehicle', data);
    });

    this.socket.on('shipment_updated', (data: any) => {
      this.handleUpdate('shipment', data);
    });
  }

  private handleUpdate(type: UpdateType, data: any): void {
    console.log(`📡 Actualizare ${type}:`, data);

    // Apelează callback-urile înregistrate
    this.callbacks[type].forEach((callback) => callback(data));

    // Notificare vizuală
    this.showNotification(
      `${type} actualizat: ${data?.message || 'Date noi disponibile'}`,
      'info'
    );
  }

  public onUpdate(type: UpdateType, callback: UpdateCallback): void {
    this.callbacks[type].push(callback);
  }

  private showNotification(message: string, type: 'info' | 'error' = 'info'): void {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'error' ? '#f44336' : '#4caf50'};
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      z-index: 10000;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    `;
    notification.textContent = message;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.remove();
    }, 3000);
  }

  public emit(event: string, data: any): void {
    if (this.isConnected && this.socket) {
      this.socket.emit(event, data);
    }
  }
}

// Inițializare automată
let wsClient: SimpleWebSocket;

document.addEventListener('DOMContentLoaded', () => {
  wsClient = new SimpleWebSocket();
  window.WebSocket = wsClient;
});

export default wsClient;
